import { Drawer } from '@/components';
import type { ComponentProps, FC } from 'react';
import { useDrawerState } from '../DrawerStateProvider';
import { AccountTitleForm } from './AccountTitleForm';

type Props = ComponentProps<typeof AccountTitleForm>;

export const AccountTitleFormDrawer: FC<Props> = ({
  initialValues,
  onSubmit,
}) => {
  const { drawerState, setDrawerState } = useDrawerState();

  return (
    <Drawer
      open={drawerState.open && drawerState.type === 'account-title'}
      onClose={() => {
        setDrawerState({ open: false });
      }}
      destroyOnClose
    >
      <AccountTitleForm initialValues={initialValues} onSubmit={onSubmit} />
    </Drawer>
  );
};
